import { Component } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent {

  constructor() { }
}



// WEBPACK FOOTER //
// /Users/Guest/Desktop/nurture/src/app/about/about.component.ts